import { useEffect, useSyncExternalStore } from 'react'

/**
 * Реестр полноэкранных оверлеев (сторис и т.п.).
 *
 * Нужен стартовым окнам: они должны ждать, пока сторис закроются. По флагам
 * `*Seen` этого не понять — они ставятся при первом тапе, а сторис продолжают
 * показываться через showThisSessionRef до закрытия. Единственный
 * детерминированный сигнал «сторис закрыты» — размонтирование их оболочки.
 */
const present = new Set<string>()
const listeners = new Set<() => void>()
let version = 0

function notify() {
  version++
  listeners.forEach((l) => l())
}

export function registerOverlay(name: string): () => void {
  present.add(name)
  notify()
  return () => {
    present.delete(name)
    notify()
  }
}

export function hasOverlays(): boolean {
  return present.size > 0
}

function subscribe(cb: () => void) {
  listeners.add(cb)
  return () => listeners.delete(cb)
}

/** Зарегистрировать оверлей на время жизни компонента. */
export function useOverlayPresence(name: string): void {
  useEffect(() => registerOverlay(name), [name])
}

/** true, когда ни один оверлей не смонтирован. */
export function useNoOverlays(): boolean {
  const v = useSyncExternalStore(subscribe, () => version, () => version)
  void v
  return !hasOverlays()
}

/** Для тестов. */
export function _resetOverlays(): void {
  present.clear()
  notify()
}
